import {AutomatizacionOperaciones} from './AutomatizacionOperaciones';
export default AutomatizacionOperaciones;
